export default "__VITE_ASSET__EO$sB4rt__"